import { defineComponent as _defineComponent } from 'vue'
import { inject, onMounted, onBeforeUnmount, computed, ref, Ref } from 'vue'
import InfoModal from '@/components/InfoModal.vue'
import { tripModificationStartModalDetail, tripModificationWithin72HoursModalDetail, tripModificationDraftInProgressModalDetail } from '@/utils/infoModals'
import tripModification from '@/store/modules/tripModification'
import { getSupportNumber, phoneFormatFilterInternational } from '@/utils/phone'
import { EventBus } from '@/utils/eventBus'
import auth from '@/store/modules/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripModificationStartDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { value: boolean };




const isWithin72HoursOfPickup = inject<Ref<boolean>>('isWithin72HoursOfPickup', ref(false))

const handleClickContinue = () => {
  tripModification.setIsOpen(true)
  tripModification.setForwardButtonDisabled(false)
  emit('input', false)
}

const tripModificationModalDetail = computed(() => {
  if (isDraftInProgress.value) {
    return tripModificationDraftInProgressModalDetail
  }
  return isWithin72HoursOfPickup.value
    ? tripModificationWithin72HoursModalDetail
    : tripModificationStartModalDetail
})

const supportNumber = computed(() => {
  const isElite = !!auth.customer?.isElite
  return getSupportNumber(isElite)
})

const formattedSupportNumber = computed(() => phoneFormatFilterInternational(supportNumber.value))

const isDraftInProgress = computed(() => tripModification.isDraftInProgress)

onMounted(() => {
  EventBus.$on('open-trip-modification-dialog', () => emit('input', true))
  EventBus.$on('close-trip-modification-dialog', () => emit('input', false))
})

onBeforeUnmount(() => {
  EventBus.$off('open-trip-modification-dialog')
  EventBus.$off('close-trip-modification-dialog')
})

return { __sfc: true,props, emit, isWithin72HoursOfPickup, handleClickContinue, tripModificationModalDetail, supportNumber, formattedSupportNumber, isDraftInProgress, InfoModal }
}

})